import styled from 'styled-components'
import { institutionalColors } from '~/design'

export const InsightTitleCell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 4px 0;
`

export const InsightTitle = styled.div`
  color: ${institutionalColors.neutral30};
  font-size: 0.9375rem;
  font-weight: 600;
  line-height: 1.3;
`

export const InsightDescription = styled.div`
  color: ${institutionalColors.neutral45};
  font-size: 0.9rem;
  line-height: 1.3;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const ListWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`

export const AlertBadge = styled.span<{ $bgColor: string; $textColor: string }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px 12px;
  border-radius: 8px;
  font-size: 0.75rem;
  letter-spacing: 0.5px;
  font-weight: 600;
  text-transform: uppercase;
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
  max-width: 100%;
  text-align: center;
  background-color: ${props => props.$bgColor};
  color: ${props => props.$textColor};

  @media (max-width: 1250px) {
    font-size: 0.7rem;
    padding: 4px 10px;
  }

  @media (max-width: 600px) {
    font-size: 0.68rem;
    padding: 4px 8px;
  }
`
